var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import './PostResultItem.scss';
import { decodeEntities } from "@wordpress/html-entities";
var PostResultItem = /** @class */ (function (_super) {
    __extends(PostResultItem, _super);
    function PostResultItem(props) {
        return _super.call(this, props) || this;
    }
    PostResultItem.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var featuredImageUrl = (_d = (_c = (_b = (_a = this.props.result) === null || _a === void 0 ? void 0 : _a._embedded) === null || _b === void 0 ? void 0 : _b['wp:featuredmedia']) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.source_url;
        return (React.createElement("li", { className: "postResultItem" },
            React.createElement("a", { className: "postResultItem-anchor", href: ((_e = this.props.result) === null || _e === void 0 ? void 0 : _e.link) ? (_f = this.props.result) === null || _f === void 0 ? void 0 : _f.link : (_g = this.props.result) === null || _g === void 0 ? void 0 : _g.link }),
            React.createElement("main", null,
                React.createElement("span", null, ((_h = this.props.result) === null || _h === void 0 ? void 0 : _h.title.rendered) ? decodeEntities((_j = this.props.result) === null || _j === void 0 ? void 0 : _j.title.rendered) : (_k = this.props.result) === null || _k === void 0 ? void 0 : _k.slug),
                React.createElement("div", null, (_o = (_m = (_l = this.props.result) === null || _l === void 0 ? void 0 : _l._embedded) === null || _m === void 0 ? void 0 : _m['wp:term']) === null || _o === void 0 ? void 0 : _o[1].map(function (result, index) {
                    return React.createElement("a", { className: "insights__item-tag", key: index, href: result.link }, result.name.length > 15 ? decodeEntities(result.name).substring(0, 15).concat('…') : decodeEntities(result.name));
                }))),
            featuredImageUrl ?
                React.createElement("figure", { className: "insights__item-figure", style: { backgroundImage: "url(" + featuredImageUrl + ")" } })
                :
                    null));
    };
    return PostResultItem;
}(React.Component));
export default PostResultItem;
